<template>
    <div>
      <v-avatar class="my-4" size="200px" color="grey">
        <img v-if="imageData" :src="imageData" alt="Your avatar">
        <v-icon v-else color="white">No avatar</v-icon>
      </v-avatar>
      <v-file-input filled width="200px" prepend-icon="fa fa-camera" accept="image/*" :rules="rules" :label="$t('profile.edit.select-profile-image')" v-model="file" v-on:change="updatePreview"></v-file-input>
      <v-alert v-if="syncResult && syncResult.status == 'OK'" type="success">{{$t('profile.edit.picture-saved-successfully')}}</v-alert>
      <v-alert v-else-if="syncResult && syncResult.status == 'INFO'" type="info"><strong>{{ syncResult.msg }}</strong></v-alert>
      <v-alert v-else-if="syncResult && syncResult.status == 'ERROR'" type="error">Unfortunately, we couldn't process your file: <strong>{{ syncResult.msg }}</strong></v-alert>
      <v-alert v-if="previewMode" type="info">Preview of how your avatar will look, don't worry if it looks stretched, this will be fixed when you save your avatar.</v-alert>
      <v-btn v-if="previewMode" color="success" @click="uploadFile">Save Avatar</v-btn>
    </div>
</template>

<script>

import profileService from "@/services/profileService";

export default {
  name: "AvatarUploadForm",
  props: {
    img: String,
  },
  data: function() {
    return {
      file: null,
      previewMode: false,
      previewImgData: null,
      syncResult: null,
      rules: [
        value => !value || value.size < 5000000 || 'Avatar size should be less than 5 MB!',
      ]
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async updatePreview() {
      if (this.file) {
        this.syncResult = null;
        this.previewImgData = URL.createObjectURL(this.file);
        this.previewMode = true;
      }
    },
    async uploadFile() {
      this.syncResult = null;
      if (this.file) {
        this.previewImgData = URL.createObjectURL(this.file);
        let formData = new FormData()
        formData.append("file", this.file, this.file.name);
        var response = await profileService.uploadAvatar(formData);
        this.syncResult = response.data;
        if (this.syncResult.status == "OK") {
          this.previewMode = false;
          this.$emit('change');
        }
      }
      else {
        this.syncResult = {
          status: "ERROR",
          msg: "Please select a file to upload."
        };
      }
    },
  },
  computed: {
    imageData() {
      return this.previewImgData || this.img;
    }
  },
};
</script>

<style scoped>
</style>